import { useState } from "react";
import { Stack, Text } from "@storyofams/react-ui";
import { useRouter } from "next/router";
import { usePostHog } from "posthog-js/react";
import { useShopify } from "~context";
import { Button } from "~components/common/Button";
import { AddToWishlistButton } from "../../components";
import { UpsellModal } from "../../UpsellModal";
import { QuantityInput } from "./QuantityInput";

export const ActionPannel = ({
  quantity,
  setQuantity,
  foundVariant,
  product,
  isUpsellDisabled = false,
  close,
}) => {
  const { addItemToCart, updatingCart, customerCompanyId, isB2B } =
    useShopify();
  const { pathname } = useRouter();
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const posthog = usePostHog();
  const autoDiscount =
    product?.autoDiscount?.value && product?.autoDiscount?.value !== "0"
      ? 1 - Number(product?.autoDiscount?.value) / 100
      : null;
  const prices = foundVariant?.quantityPriceBreaks?.nodes;
  const getPrice = () => {
    if (customerCompanyId && prices && isB2B) {
      const getPriceByQuantity = () => {
        for (let tier of prices) {
          if (quantity >= tier.minimumQuantity) {
            return tier.price.amount;
          }
        }
        return foundVariant.priceV2.amount;
      };
      const price = getPriceByQuantity();
      return "€" + (price * quantity).toFixed(2);
    }
    if (autoDiscount && foundVariant)
      return (
        "€" + (foundVariant.priceV2.amount * autoDiscount * quantity).toFixed(2)
      );
    else if (foundVariant)
      return "€" + (foundVariant.priceV2.amount * quantity).toFixed(2);
    else return "";
  };
  const price = getPrice();
  return (
    <>
      <Stack
        space={[1, 1.5]}
        backgroundColor={"inherit"}
        alignItems={"top"}
        width={"100%"}
      >
        <>
          <QuantityInput quantity={quantity} setQuantity={setQuantity} />
          <Button
            variant="primary"
            fontSize={["16px", 2.25]}
            height="56px"
            fontWeight={500}
            disabled={!foundVariant?.id || !foundVariant?.availableForSale}
            isLoading={updatingCart}
            onClick={() => {
              if (pathname !== "/products/[handle]")
                posthog.capture("product_card_add_to_cart", {
                  variant_id: foundVariant?.id,
                  properties: {
                    $process_person_profile: false,
                  },
                });
              else
                posthog.capture("Clicked Add to Cart", {
                  source: "Product Page",
                  product: product.title,
                });
              addItemToCart(
                [
                  {
                    quantity,
                    merchandiseId: foundVariant?.id,
                  },
                ],
                () => {
                  if (close) close();
                  else if (!isUpsellDisabled) setIsUpsellOpen(true);
                }
              );
            }}
            flex={1}
            px={[0, "initial"]}
          >
            <Text>{`Bestel nu!${price && " - " + price}`}</Text>
          </Button>
        </>

        <AddToWishlistButton product={product} />
      </Stack>
      <UpsellModal
        isOpen={isUpsellOpen}
        close={() => setIsUpsellOpen(false)}
        product={product}
      />
    </>
  );
};
